import { getCurrentContactEntity } from "@/models/contact";
import { dealModel, DealRecord } from "@/models/deal";
import { userIsCreatorConstraint } from "@/orm/model";
import { Route } from "@/paths";
import { Card, Group, Stack, Text } from "@mantine/core";
import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { HiExternalLink } from "react-icons/hi";
import { generatePath, Link } from "react-router-dom";

export const DealList = () => {
  const contactEntity = getCurrentContactEntity();

  const atm = useMemo(() => {
    return contactEntity.getObserveManyOwnersAtom<DealRecord>(
      dealModel,
      "belongsToDealIds",
      {
        constraints: [userIsCreatorConstraint()],
      },
    );
  }, []);

  const { entities: dealEntites, loading } = useAtomValue(atm);

  return (
    <Stack gap={"xs"}>
      <Text size="sm" fw={600}>
        Linked Deals
      </Text>
      <Stack gap={"xs"}>
        {loading && <Text>Loading...</Text>}
        {!loading && (dealEntites || [])?.length === 0 && (
          <Text size="sm" c="dimmed">
            No deals attached to this contact
          </Text>
        )}
        {dealEntites?.map((deal) => (
          <Card
            withBorder
            key={deal.id}
            component={Link}
            to={generatePath(Route.Deal, { dealId: deal.id })}
          >
            <Group>
              <Text size="sm" fw={500}>
                {deal.data.companyName || "Untitled Deal"}
              </Text>
              <Text c="dimmed" size="xs">
                {deal.data.createdAt
                  ? deal.data.createdAt.toDate().toLocaleDateString()
                  : ""}
              </Text>

              <HiExternalLink color="gray" style={{ marginLeft: "auto" }} />
            </Group>
          </Card>
        ))}
      </Stack>
    </Stack>
  );
};
